import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyBankAccountQueryType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyBankAccount/patchBodyBankAccountQuery.type';

export const patchBodyBankAccountFunction = (
  params: PatchBodyBankAccountQueryType,
) => {
  return fetchApi.patch(`/body/reports/${params.id}/bank_information/`, {
    ...params.formData,
  });
};
